import { createFileRoute } from '@tanstack/react-router';
import { InstrumentsCalendarFull } from '@/features/bookings/InstrumentsCalendarFull';

export const Route = createFileRoute('/_app/instruments-calendar')({
  component: InstrumentsCalendarFull,
});
